query LookupTripSectionSupplierSearch(
  $lookupName: String!
  $travelerId: UUID
  $tripSectionId: UUID!
  $first: Int
) {
  lookupTripSectionSupplierSearch(
    lookupName: $lookupName
    tripSectionId: $tripSectionId
    travelerId: $travelerId
    first: $first
    orderBy:_CREATED_DATE_DESC
  ) {
    nodes {
      id
      _fullName
      _isAliasOriginalNameViewable
      _isAliasInvoked
      _isUpdatable
      _isApproved
      supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC, first: 1) {
        nodes {
          isPrimary
          addressLine1
          addressLine2
          cityName
          postalCode
          stateRegion {
            stateRegion
            country {
              country
            }
            stateRegionDescription
          }
          telephoneNumber
          emailAddress
        }
      }
      vendorNumber
      vendorServiceRate
    }
  }
}
